import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './stores'
import { sync } from 'vuex-router-sync'

import 'bootstrap'
import VueClipboard from 'vue-clipboard2'
import VueJWT from 'vuejs-jwt'
import VeeValidate from 'vee-validate'
import MicrobaResults from '@microbadevs/report'
import i18n from '@microbadevs/report/src/language-pack'
import VueI18n from 'vue-i18n'

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueI18n)
Vue.use(MicrobaResults)
Vue.use(VueClipboard)
Vue.use(VeeValidate)
Vue.use(VueJWT, {})

sync(store, router)

Vue.config.productionTip = false

if (process.env.VUE_APP_API_ROOT) {
  window.api_path = process.env.VUE_APP_API_ROOT
} else if (localStorage.getItem('api_path')) {
  window.api_path = localStorage.getItem('api_path')
} else {
  window.api_path = 'API PATH NOT SET'
}
i18n.locale = 'en'
localStorage.setItem('locale', i18n.locale)
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
